import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// import redux toolkit
import { store } from "services/redux/store";
import { Provider } from "react-redux";

// import styles
import "assets/css/app.css";
import "assets/css/core.css";
import "react-toastify/dist/ReactToastify.css";
import "assets/css/index-crossbrowser.css";
import "assets/css/index.css";
import "assets/css/momeento-crossbrowser.css";
import "assets/css/momento.css";
// import "assets/css/custom-phone-input.css";

// import helmet
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <Provider store={store}>
        <HelmetProvider context={{}}>
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </HelmetProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
